import { apiClient } from './client';

export interface TenantRecord {
  tenantId:   string;
  name:       string;
  code:       string | null;
  logoUrl:    string | null;
  status:     'ACTIVE' | 'INACTIVE';
  maxRanchos: number;
  allowDemoLogin: boolean;
  /** Si true, exige OTP por Telegram incluso tras login con contraseña (doble factor). Default true. */
  requireOtp: boolean;
  /** Segundo factor por Telegram: REQUIRED (todos), IF_LINKED (solo quien tiene Telegram) o NEVER. */
  otpMode?: OtpMode;
  accessHours?: { start: string; end: string };
  passwordPolicy?: { minLength: number; maxAgeDays?: number; historyCount?: number };
  featureFlags?: Record<string, boolean>;
  createdAt:  string;
}

export const fetchAllTenants = async (): Promise<TenantRecord[]> =>
  (await apiClient.get('/api/super-admin/tenants')).data;

export type OtpMode = 'REQUIRED' | 'IF_LINKED' | 'NEVER';

export const createTenant = async (data: { name: string; code?: string; logoUrl?: string }) =>
  (await apiClient.post('/api/super-admin/tenants', data)).data;

export const updateTenant = async (
  tenantId: string,
  data: {
    name?: string;
    code?: string;
    logoUrl?: string;
    status?: string;
    allowDemoLogin?: boolean;
    requireOtp?: boolean;
    otpMode?: OtpMode;
    accessHours?: { start: string; end: string } | null;
    passwordPolicy?: { minLength: number; maxAgeDays?: number; historyCount?: number } | null;
    featureFlags?: Record<string, boolean> | null;
  },
) => (await apiClient.patch(`/api/super-admin/tenants/${tenantId}`, data)).data;

export interface ImpersonateResponse {
  token: string;
  tenant: { tenantId: string; name: string; code: string | null; logoUrl: string | null };
}

export const impersonateTenant = async (tenantId: string): Promise<ImpersonateResponse> =>
  (await apiClient.post(`/api/super-admin/tenants/${tenantId}/impersonate`)).data;

/** Soft-delete: solo permitido si el tenant ya está INACTIVE. */
export const deleteTenant = async (tenantId: string) =>
  (await apiClient.delete(`/api/super-admin/tenants/${tenantId}`)).data;
